<div class="content-wrap tw-flex tw-flex-col tw-justify-center">
  <container-default-header
    [showIntrackLogo]="showIntrackLogo"
    [languageFromQueryParams]="language"
    (languageFromSelect)="languageFromSelect.emit($event)"
    [showLanguage]="showLanguage"
  >
    <!--    TODO: very temporary solution until this feature will be moved as a separate app in the upcoming sprint-->
    <ng-content select="[headerTitle]"></ng-content>
  </container-default-header>
  <div class="content">
    <img class="logo tw-self-center" src="assets/core/images/bosch-logo.svg" *ngIf="isLogoAvailable" />
    <ng-content></ng-content>
  </div>

  <div class="footer" *ngIf="isFooterAvailable">
    <div class="intrack-logo"></div>
    <div class="copyrights tw-self-center">
      {{ 'footer.copyrights' | translate : { year: currentYear } }}
    </div>
  </div>
</div>
